import { Radio, RadioGroup } from '@chakra-ui/react';
import useOrder from '@hooks/useOrder';
import { myInfoSelector } from '@stores/myInfo';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { TbTruckDelivery } from 'react-icons/tb';

const MESSAGE = [
  {
    label: 'nok',
    value: '노크',
  },
  {
    label: 'silence',
    value: '무음',
  },
  {
    label: 'call',
    value: '전화',
  },
];

export default function RequestMessageToDelivery() {
  const { updateOrderInfo } = useOrder();
  const { t } = useTranslation('messageRequest');
  const { latestInfo } = useSelector(myInfoSelector);

  useEffect(() => {
    updateOrderInfo({
      messageToDelivery:
        latestInfo?.latestMessageToDelivery || MESSAGE[0].value,
    });
  }, []);

  return (
    <section className="flex gap-[6px] flex-col">
      <div className="flex items-center justify-center gap-[6px]">
        <div>
          <TbTruckDelivery size="18px" />
        </div>
        <span className="font-bold text-lg">
          {t('store:special_request_label')}
        </span>
      </div>
      <div>
        <RadioGroup
          as="ul"
          colorScheme="red"
          defaultValue={latestInfo?.latestMessageToDelivery ?? MESSAGE[0].value}
          onChange={(value) => updateOrderInfo({ messageToDelivery: value })}
        >
          {MESSAGE.map((msg) => (
            <li key={msg.label}>
              <Radio value={msg.value}>{t(`${msg.label}`)}</Radio>
            </li>
          ))}
        </RadioGroup>
      </div>
    </section>
  );
}
